<template>
	<!-- TODO: define color palette in tailwind config using existing vars -->
	<span
		class="text-sm rounded-full px-2 py-1 bg-[var(--background-secondary)] text-[var(--accent-primary)]"
	>
		<slot />
	</span>
</template>
